import React from "react";
import { TitleWithSearch } from "../../components/titleWithSearch";
import "../../assets/styles/tableEap.css";
import chevron from "../../assets/img/Icon awesome-chevron-circle-right.svg";
import { Link, useParams } from "react-router-dom";
import Stack from "@mui/material/Stack";
import Pagination from "@mui/material/Pagination";
import { ModalInfos } from "../../components/modal";
import Loading from "../../components/Loading";
import Switch, { SwitchProps } from "@mui/material/Switch";
import { styled } from "@mui/material/styles";
import { downloadPlanilha } from "../../download-planilha-soc"
import axiosInstance from "../../auth/axiosInstance";

const Table = () => {
  const [initialData, setInitialData] = React.useState([]);
  const param = useParams();
  const [searchValue, setSearchValue] = React.useState("");
  const [checked, setChecked] = React.useState(false);
  const [label, setlabel] = React.useState("Projeto atualizado com sucesso!");
  const [labelError, setlabelError] = React.useState({
    label: "Erro ao atualizar Projeto!",
    sugestao: "Favor tentar novamente",
  });
  const [showModal, setShowModal] = React.useState(false);
  const [showModal2, setShowModal2] = React.useState(false);
  const [selectFilter, setSelectFilter] = React.useState(0);
  const [custoTotal, setCustoTotal] = React.useState(0);
  const [custoTotalMW, setCustoTotalMW] = React.useState(0);
  const [moeda, setMoeda] = React.useState("brl");

  React.useEffect(() => {
    getInitial();
  }, [])

  async function getInitial() {
    await axiosInstance(`filter/EAP/${param.id}`).then(
      async (res) => {
        const dataFilter = res.data.eaps.filter(
          (el) => el.eapId === param.id
        );
        setInitialData(dataFilter);
        await axiosInstance(`filter/Eap_Info`).then((res) => {
          const dataFilter2 = res.data.filter((el) => el.eapId === param.id);
          let custoTotal = 0;
          dataFilter.forEach((value) => {
            if (!value.check.includes("T")) {
              custoTotal = custoTotal += value.custoTotal;
            }
            else {
              const regex = new RegExp(`^${value.item}\\b`)
              value.custoTotal = dataFilter.reduce((acc, curr) => {
                if (curr.custoTotal && regex.test(curr.item) && curr.check.includes("S")) {
                  return acc + curr.custoTotal
                }
                else return acc
              }, 0)
            }
          });
          if (dataFilter2.length > 0) {
            setMoeda(dataFilter2[0].moeda);
            setCustoTotal((custoTotal).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            if (typeof dataFilter2[0].potencia === "number") {
              setCustoTotalMW((custoTotal / dataFilter2[0].potencia).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }));
            }
          }
        });
      }
    );
  }

  const [page, setPage] = React.useState(1);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const paginate = (array, page_size, page_number) => {
    return array.slice((page_number - 1) * page_size, page_number * page_size);
  };

  const searchHandler = ({ target }) => {
    setSearchValue(target.value);
    setSelectFilter(target.value);
    setPage(1);
  };

  // const filteredData = searchValue
  //   ? initialData.filter((value) =>
  //     Object.values(value)
  //       .join(" ")
  //       .toLowerCase()
  //       .includes(searchValue.toLowerCase())
  //   )
  //   : initialData;

  const filteredData = searchValue
    ? checked === false
      ? initialData.filter((value) =>
        Object.values(value)
          .join(" ")
          .toLowerCase()
          .includes(searchValue.toLowerCase())
      )
      : initialData.filter((value) =>
        value.codigoCpu == selectFilter
          ? Object.values(value)
            .join(" ")
            .toLowerCase()
            .includes(searchValue.toLowerCase())
          : null
      )
    : initialData;

  const paginatedData = paginate(filteredData, 30, page);
  const totalPages = Math.ceil(filteredData.length / 30);

  React.useEffect(() => {
    getInitial();
  }, []);

  async function getCpuAndInsumosWithDownload() {
    let objects = [{ cpu: [] }, { insumos: [] }, { moeda: [] }];
    await axiosInstance(`filter/Cpu_bd/${param.id}`)
      .then((response) => { objects[0].cpu = response.data })
    await axiosInstance(`filter/Eap_Insumos_Custo/${param.id}`)
      .then((response) => { objects[1].insumos = response.data })
    await axiosInstance(`moeda/${param.id}`)
      .then((response) => { objects[2].moeda = response.data })
    return objects;
  }

  async function callDownload() {
    setIsLoadingDownload(true)
    const data = await getCpuAndInsumosWithDownload()
    downloadPlanilha(initialData, data[0].cpu, data[1].insumos, data[2].moeda, param.id)
    setIsLoadingDownload(false)
  }

  const [isLoading, setIsLoading] = React.useState(false);
  const [isLoadingDownload, setIsLoadingDownload] = React.useState(false);

  function callLoading() {
    setIsLoading(true);
    atualizarValores();
  }

  async function atualizarValores() {
    axiosInstance
      .put(`update/values/${param.id}`, {})
      .then((res) => {
        if (res.status === 200) {
          setIsLoading(false);
          setlabel("Projeto atualizado com sucesso!");
          setShowModal(true);
        }
      })
      .catch((error) => {
        setIsLoading(false);
        setShowModal2(true);
        setlabelError({
          label: "Erro ao atualizar Projeto!",
          sugestao: "Favor tentar novamente",
        });
      });
  }

  const changeFilter = ({ target }) => {
    setChecked(target.checked);
  };

  const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 28,
    height: 16,
    padding: 0,
    display: "flex",
    "&:active": {
      "& .MuiSwitch-thumb": {
        width: 15,
      },
      "& .MuiSwitch-switchBase.Mui-checked": {
        transform: "translateX(9px)",
      },
    },
    "& .MuiSwitch-switchBase": {
      padding: 2,
      "&.Mui-checked": {
        transform: "translateX(12px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          opacity: 1,
          backgroundColor:
            theme.palette.mode === "dark" ? "#177ddc" : "#00838D",
        },
      },
    },
    "& .MuiSwitch-thumb": {
      boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
      width: 12,
      height: 12,
      borderRadius: 6,
      transition: theme.transitions.create(["width"], {
        duration: 200,
      }),
    },
    "& .MuiSwitch-track": {
      borderRadius: 16 / 2,
      opacity: 1,
      backgroundColor:
        theme.palette.mode === "dark"
          ? "rgba(255,255,255,.35)"
          : "rgba(0,0,0,.25)",
      boxSizing: "border-box",
    },
  }));

  return (
    <section className="body-table-eap">
      <div
        style={isLoading ? { display: "flex" } : { display: "none" }}
        className="absolute-loading"
      >
        <Loading content="Aguarde enquanto atualizamos os valores" />
      </div>
      <div style={isLoadingDownload ? { display: "flex" } : { display: "none" }} className="absolute-loading">
        < Loading content="Aguarde enquanto geramos a planilha para download" />
      </div>
      <div className="header-eap">
        <TitleWithSearch
          title={`${param.id} - EAP`}
          label="Procurar EAP"
          chevron={true}
          onChange={searchHandler}
          route="/"
          placeholder="Pesquise por Check, Item, Descrição, Unidade, Quantidade"
          botao={true}
          onClick={() => callLoading()}
          fontSizeButton="14px"
          labelButton="Atualizar Valores"
          onClickDownload={() => callDownload()}
          botaoDownload={true}
          downloadLabel="Baixar Planilha"
        />
        {/* <div className="toggle">
          <h2 className="title-toggle2"> Filtrar por: </h2>
          <Stack direction="row" spacing={1} alignItems="center">
            <h3 className="title-toggle">Todos</h3>
            <AntSwitch
              checked={checked}
              onChange={changeFilter}
              inputProps={{ "aria-label": "controlled" }}
            />
            <h3 className="title-toggle ">Código CPU</h3>
          </Stack>
        </div> */}
      </div>
      <div className="dados-table">
        <div style={{ display: "flex", marginTop: 3, marginBottom: 3 }}>
          <h1
            className="w700 montserrat infos"
            style={{ marginRight: 8, fontWeight: 600 }}
          >
            Custo Total:
          </h1>
          <h2 className="montserrat w500 infos" style={{ fontWeight: 500 }}>
            {custoTotal === 0 ? "Não foi possível calcular o custo total" : custoTotal}
          </h2>
        </div>
        <div style={{ display: "flex", marginTop: 3, marginBottom: 3 }}>
          <h1
            className="w700 montserrat infos"
            style={{ marginRight: 8, fontWeight: 600 }}
          >
            Custo Total/MW:
          </h1>
          <h2 className="montserrat w500 infos" style={{ fontWeight: 500 }}>
            {custoTotal === 0 ? "Potência não definida" : custoTotalMW}
          </h2>
        </div>
        <div style={{ display: "flex" }}>
          <h1
            className="w700 montserrat infos"
            style={{ marginRight: 8, fontWeight: 600 }}
          >
            Moeda:
          </h1>
          <h2 className="montserrat w500" style={{ fontSize: 20, fontWeight: 500 }}>
            {moeda}
          </h2>
        </div>
      </div>

      <div style={{ maxHeight: "69%" }} className="table-wrapper">
        <table className="table-eap">
          <thead>
            <tr>
              <th>Check</th>
              <th>Item</th>
              <th>Código da CPU</th>
              <th className="descricao-th">Descrição do Item</th>
              <th>Unidade</th>
              <th>Quantidade</th>
              <th>Custo Unitário</th>
              <th>Custo Total</th>
              <th></th>
            </tr>
          </thead>
          <tbody>

            {
              paginatedData.map((value) => {
                const backgrounds = ["#10232E", "#183545", "#3C7C9F", "#67A7C8"]
                var i;
                if (value.check.includes('S')) {
                  return (
                    <tr className="tr-body-eap">
                      <td>{value.check}</td>
                      <td>{value.item}</td>
                      <td>{value.codigoCpu}</td>
                      <td className="descricao-td">{value.descricaoItem}</td>
                      <td>{value.unidade === 'null' ? ' ' : value.unidade}</td>
                      <td>{value.quantidade !== null ? (value.quantidade).toFixed(4) : ' '}</td>
                      <td>{value.custoUnitario !== null ? (value.custoUnitario).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ' '}</td>
                      <td>{value.custoTotal !== null ? (value.custoTotal).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ' '}</td>
                      <td><Link to={`/eap/${value.eapId}/${value.eapId}`}><button onClick={(e) => {
                        localStorage.setItem('cpuId', value.codigoCpu)
                      }}><img src={chevron} alt='chevron' /></button></Link></td>
                    </tr>
                  )
                } else if (value.check.includes('T')) {
                  if (value.item.split(".").length - 1 == 1) i = 1
                  if (value.item.split(".").length - 1 == 2) i = 2
                  if (value.item.split(".").length - 1 == 3) i = 3
                  if (!value.item.includes(".")) i = 0
                  return (
                    <tr className="tr-title-eap" style={{ backgroundColor: `${backgrounds[i]}` }}>
                      <td>{value.check}</td>
                      <td>{value.item}</td>
                      <td></td>
                      <td className="descricao-td">{value.descricaoItem}</td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{value.custoTotal.toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                      <td></td>
                    </tr>
                  )
                }
              })
            }
          </tbody>
        </table>
        <div className="page-component">
          <Stack spacing={2}>
            <Pagination
              count={totalPages}
              page={page}
              onChange={handleChange}
            />
          </Stack>
        </div>
      </div>

      <ModalInfos
        checked={showModal}
        onClick={() => setShowModal(false)}
        label={label}
      />

      <ModalInfos
        checked={showModal2}
        error
        onClick={() => setShowModal2(false)}
        label={labelError.label}
        sugestao={labelError.sugestao}
      />
    </section >
  );
};

export default Table;
